export const getTypeIncidencesInitialState = {
	incidences: null,
	error: null,
	errorShow: false,
	loading: false,
};
